<template>
  <div class="cadastro">
    <form
      class="tutorial-form"
      @submit.prevent="salvarTutorial"
    >
      <div class="form-row">
        <label class="form-field">
          <span class="field-label">Título</span>
          <input
            type="text"
            placeholder="Ex.: Como cadastrar uma atividade"
            v-model="newTutorial.titulo"
            :disabled="isLoadingTutorial || isSavingTutorial"
          />
        </label>
        <label class="form-field">
          <span class="field-label">URL do vídeo</span>
          <input
            type="text"
            placeholder="https://..."
            v-model="newTutorial.urlVideo"
            :disabled="isLoadingTutorial || isSavingTutorial"
          />
        </label>
      </div>

      <label class="form-field">
        <span class="field-label">Descrição</span>
        <textarea
          rows="3"
          placeholder="Explique brevemente o que o tutorial ensina"
          v-model="newTutorial.descricao"
          :disabled="isLoadingTutorial || isSavingTutorial"
        ></textarea>
      </label>

      <div class="buttons-container">
        <button
          class="btn-secondary"
          @click.prevent="voltar"
          :disabled="isLoadingTutorial || isSavingTutorial"
        >
          Voltar
        </button>
        <button
          type="submit"
          class="btn-primary"
          :disabled="isLoadingTutorial || isSavingTutorial"
        >
          {{ mensagemBotao() }}
        </button>
      </div>
    </form>
  </div>
</template>
<script setup>
import { useTutoriais } from "@/composables/useTutoriais";
import router from "@/router";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const {
  saveTutorial,
  fetchTutorialById,
  tutorial,
  updateTutorial,
  isLoadingTutorial,
  isSavingTutorial,
} = useTutoriais();

const newTutorial = ref({
  titulo: "",
  descricao: "",
  urlVideo: "",
  topicoAjuda: "",
});

const emits = defineEmits(["voltar"]);

const edicao = route.query["tutorial-editado"];

function mensagemBotao() {
  if (edicao) {
    return "Confirmar edição";
  }
  return "Cadastrar tutorial";
}

async function salvarTutorial() {
  if (edicao) {
    const tutorialId = newTutorial.value.id;
    newTutorial.value.topicoAjuda = newTutorial.value["topicoAjudaId"];
    await updateTutorial(tutorialId, newTutorial.value);
  } else {
    const topicoId = route.query.topico;
    newTutorial.value.topicoAjuda = topicoId;

    await saveTutorial(newTutorial.value);
  }

  voltar();
}

function voltar() {
  const query = { ...route.query };
  query.modal = null;
  query["tutorial-editado"] = null;
  router.push({ query: query });
  emits("voltar");
}

onMounted(async () => {
  const tutorialId = route.query["tutorial-editado"];
  if (tutorialId) {
    await fetchTutorialById(tutorialId);

    newTutorial.value = tutorial.value;
  }
});
</script>
<style scoped>
.tutorial-form {
  display: flex;
  flex-direction: column;
  width: 600px;
  max-width: 100%;
  gap: 14px;
  padding: 18px;
  margin-bottom: 20px;
  background-color: var(--roxo-superficie);
  border: 1px solid var(--roxo-superficie);
  border-radius: 10px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--cinza-escuro);
}

.tutorial-form input,
.tutorial-form textarea {
  padding: 10px 12px;
  font-size: 14px;
  font-family: inherit;
  color: var(--cinza-escuro);
  background-color: var(--branco);
  border: 1px solid var(--cinza-claro);
  border-radius: 8px;
  outline: none;
  resize: vertical;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
}

.tutorial-form input:focus,
.tutorial-form textarea:focus {
  border-color: var(--roxo-claro);
  box-shadow: 0 0 0 3px hsla(258, 70%, 58%, 0.12);
}

.tutorial-form input::placeholder,
.tutorial-form textarea::placeholder {
  color: var(--cinza-medio);
}

.buttons-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.btn-primary {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  color: var(--branco);
  background-color: var(--roxo-claro);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.btn-primary:hover {
  background-color: var(--roxo-medio);
}

.btn-secondary {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  color: var(--roxo-claro);
  background-color: var(--branco);
  border: 2px solid var(--roxo-claro);
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

@media (max-width: 600px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}
</style>
